$(document).ready(() => {
    const updateTitleHeight = () => {
        let titleHeight = $(".multicolumn-sec-v1 .multicolumn-info .multicolumn-info-title-wrap").outerHeight(true);
        $(".multicolumn-sec-v1 slider-component").css("--title-height", `${titleHeight}px`);
    };

    // Initial call
    updateTitleHeight();

    // Update on window resize
    $(window).on("resize", updateTitleHeight);
});
